import { BadgeCheck } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

export const ABCA_REG = "ABCA-126785";

const FACTS = [
  ["Registered business", "District Gas Light LLC T/A District Gas Light"],
  ["Registration number", ABCA_REG],
  ["Registered as", "Retailer with Delivery (Medical Cannabis Program)"],
  ["Address", "1738 14th Street NW, Washington, DC 20009"],
];

export const LicenseSection = () => (
  <section className="bg-brand-sand py-20 sm:py-28" data-testid="abca-license-section">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2">
      <Reveal>
        <SectionHead eyebrow="Licensed & legit" title="ABCA-licensed medical cannabis retailer">
          <p className="mt-4 text-base leading-relaxed text-neutral-600">
            District Gaslight is registered with DC's Alcoholic Beverage and Cannabis Administration (ABCA) under the District's Medical Cannabis Program. Our license is posted in the shop, and you can view it here.
          </p>
        </SectionHead>
        <dl className="mt-8 divide-y divide-neutral-300 border-y border-neutral-300">
          {FACTS.map(([k, v]) => (
            <div key={k} className="flex flex-col gap-1 py-3 sm:flex-row sm:justify-between sm:gap-6">
              <dt className="text-xs font-bold uppercase tracking-[0.18em] text-neutral-500">{k}</dt>
              <dd className="text-sm font-semibold sm:text-right" data-testid={`license-${k.toLowerCase().replace(/\s+/g, "-")}`}>{v}</dd>
            </div>
          ))}
        </dl>
        <p className="mt-6 flex items-center gap-2 text-sm font-semibold"><BadgeCheck className="h-5 w-5 text-brand-red" /> Verify licensed retailers anytime at abca.dc.gov.</p>
      </Reveal>
      <Reveal delay={0.1}>
        <a href="/img/abca-license.webp" target="_blank" rel="noopener noreferrer" className="group mx-auto block max-w-md" data-testid="abca-license-image-link" aria-label="View District Gaslight's ABCA registration certificate full size">
          <img
            src="/img/abca-license.webp"
            alt={`DC ABCA Medical Cannabis Program registration certificate for District Gas Light, registration number ${ABCA_REG}, 1738 14th Street NW`}
            width="640"
            height="853"
            loading="lazy"
            className="w-full -rotate-1 rounded-lg border-8 border-white shadow-[0_24px_60px_rgba(0,0,0,0.18)] transition-transform duration-500 group-hover:rotate-0"
          />
          <span className="mt-3 block text-center text-xs font-semibold text-neutral-500">Tap to view full size</span>
        </a>
      </Reveal>
    </div>
  </section>
);
